import type { CreateFaqPayload, Faq, UpdateFaqPayload } from '@/domain/faqs/entities/faq.entity'
import type { FaqRepository } from '@/domain/faqs/repositories/faq_repository'
import { mapFaqDtoToEntity } from '../mappers/faq.mapper'
import { FaqsRtkDatasource } from '../datasources/faqs_rtk_datasource'

export class FaqRepositoryImpl implements FaqRepository {
  constructor(private readonly remote: FaqsRtkDatasource = new FaqsRtkDatasource()) {}

  async list(): Promise<Faq[]> {
    const items = await this.remote.list()
    return items.map(item => mapFaqDtoToEntity(item))
  }

  async getById(id: string): Promise<Faq> {
    const item = await this.remote.getById(id)
    return mapFaqDtoToEntity(item)
  }

  async create(payload: CreateFaqPayload): Promise<Faq> {
    const item = await this.remote.create(payload)
    return mapFaqDtoToEntity(item as Faq)
  }

  async update(payload: UpdateFaqPayload): Promise<Faq> {
    const item = await this.remote.update(payload)
    return mapFaqDtoToEntity(item as Faq)
  }

  async delete(id: string): Promise<void> {
    await this.remote.delete(id)
  }
}

export const faqRepository = new FaqRepositoryImpl()
